import { organizationInfo } from "@/mocks/home";

const values = [
  {
    id: 1,
    title: "Misi Kami",
    description:
      "Membantu golongan yang memerlukan melalui bantuan kebajikan, pendidikan dan kemanusiaan yang berterusan.",
    icon: "ri-crosshair-line",
  },
  {
    id: 2,
    title: "Visi Kami",
    description:
      "Membina masyarakat Malaysia yang penyayang, berdaya saing dan saling membantu tanpa mengira kaum dan agama.",
    icon: "ri-eye-line",
  },
  {
    id: 3,
    title: "Nilai Kami",
    description:
      "Amanah, telus dan ihsan dalam setiap dana yang disalurkan kepada mereka yang benar-benar memerlukan.",
    icon: "ri-heart-3-line",
  },
];

export default function About() {
  return (
    <section id="tentang" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Image */}
          <div className="w-full lg:w-1/2">
            <div className="relative w-full h-[300px] md:h-[420px] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20group%20of%20diverse%20Malaysian%20volunteers%20and%20children%20smiling%20together%20holding%20hands%20in%20a%20community%20gathering%2C%20warm%20hopeful%20unity%20and%20togetherness%2C%20soft%20natural%20golden%20light%2C%20editorial%20documentary%20photography%20with%20clean%20warm%20composition%20and%20gentle%20depth%20of%20field&width=800&height=600&seq=tentang-kami-01&orientation=landscape"
                alt="Komuniti Kelab Kemajuan Insan Malaysia"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Text */}
          <div className="w-full lg:w-1/2">
            <span className="inline-block text-primary-600 text-sm font-semibold uppercase tracking-wider mb-3">
              Tentang Kami
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950 leading-tight">
              Siapa Kami & Mengapa Kami Berkhidmat
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              {organizationInfo.name} ialah sebuah pertubuhan kebajikan yang
              berdaftar di bawah {organizationInfo.act}. Sejak penubuhannya,
              kami komited untuk membantu keluarga berpendapatan rendah, anak
              yatim, warga emas dan komuniti terpinggir di seluruh negara.
            </p>

            <div className="mt-8 space-y-6">
              {values.map((item) => (
                <div key={item.id} className="flex items-start gap-4">
                  <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 shrink-0">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900">
                      {item.title}
                    </h3>
                    <p className="mt-1 text-sm text-foreground-600 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <a
              href="#program"
              className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              Lihat Program Kami
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}